// This icon file is generated automatically.
var PUnderlineOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.88 10.56H1.12a.12.12 0 00-.12.12v.95c0 .07.06.12.13.12h9.75c.06 0 .12-.05.12-.12v-.95a.12.12 0 00-.13-.12zM6 9.37a4.04 4.04 0 004.06-4.06V.44c0-.1-.08-.19-.19-.19h-.93c-.1 0-.19.08-.19.19V5.3a2.75 2.75 0 01-5.5 0V.44c0-.1-.08-.19-.19-.19h-.94c-.1 0-.18.08-.18.19V5.3A4.04 4.04 0 006 9.38z", "fill-rule": "nonzero" } }] }, "name": "p-underline", "theme": "outlined" };
export default PUnderlineOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PUnderlineOutlined.js
// module id = 3694
// module chunks = 0